import HomeConfig from './HomeConfig';

export {HomeConfig};